import React from "react";
import { classNames } from "../../shared/utility";
import { InputNumber } from "primereact/inputnumber";
import type { InputNumberProps, InputNumberValueChangeEvent } from "primereact/inputnumber";

export interface NumericInputChangeEvent {
  target: { name: string; value: number | string };
}

interface InputNumberOnlyProps extends Omit<InputNumberProps, "onChange" | "onValueChange" | "value"> {
  parentClass?: string;
  label?: React.ReactNode;
  value?: number | null;
  labelOn?: boolean;
  error?: string;
  explanation?: React.ReactNode;
  labelClass?: string;
  onChange?: (event: NumericInputChangeEvent) => void;
}

export default function InputNumberOnly(props: InputNumberOnlyProps) {
  const {
    parentClass,
    className,
    label,
    name,
    onChange,
    value,
    labelOn,
    error,
    suffix,
    explanation,
    labelClass,
    ...other
  } = props;

  // PrimeReact InputNumber uses onValueChange({ value }) — useForm expects e.target.name/value
  const handleValueChange = (e: InputNumberValueChangeEvent) => {
    if (!onChange) return;
    const raw = e?.value;
    onChange({
      target: {
        name: name ?? "",
        value: raw === null || raw === undefined ? "" : raw,
      },
    });
  };

  return (
    <div className={parentClass || undefined}>
      {labelOn ? (
        <label
          htmlFor={name}
          className={classNames(
            labelClass ? labelClass : "text-sm",
            "block font-medium text-gray-900 mb-2"
          )}
        >
          {label}
        </label>
      ) : null}
      <div>
        <InputNumber
          name={name}
          className={className}
          value={value}
          onValueChange={handleValueChange}
          onKeyDown={(e) => e.stopPropagation()}
          suffix={suffix}
          {...other}
        />

        {error ? <p className="font-medium text-red-500">{error}</p> : null}
      </div>
    </div>
  );
}
